import Banner from '../../pages/Banner';
import PartnerLogos from '../../pages/PartnerLogos';
import StoryAboutUs from '../../pages/StoryAboutUs';
import PageTransition from '../../pages/PageTransition';
import OurServices from '../../pages/OurServices';
import AboutUs from '../../pages/AboutUs';

function Header() {
    return (

        <PageTransition>
            <Banner />
            <StoryAboutUs />
            <PartnerLogos />
            <AboutUs />
            <OurServices />
        </PageTransition>

    );
}

export default Header;
